(() => {
  'use strict';
  async function boot() {
    const root = document.querySelector('[data-nspire-catalog="gear"]');
    if (!root || root.dataset.gearPurchaseReady) return;
    root.dataset.gearPurchaseReady = 'true';
    const config = JSON.parse(root.querySelector('[data-gear-purchase-config]').textContent);
    const template = root.querySelector('[data-gear-purchase-template]');
    const parts = template.content.cloneNode(true);
    const upsell = parts.querySelector('[data-gear-upsell]');
    const klarna = parts.querySelector('.klarna-payment-box');
    const style = parts.querySelector('style');
    if (style) root.append(style);
    const buy = root.querySelector('.buy-buttons-block');
    buy.before(upsell);
    const payment = root.querySelector('.st_appblock_wrapper');
    (payment || buy).after(klarna);
    const base = window.Shopify?.routes?.root || '/';
    const money = cents => '\u20ac ' + (Number(cents)/100).toLocaleString('nl-NL',{minimumFractionDigits:Number(cents)%100?2:0,maximumFractionDigits:2});
    const getProduct = async handle => {
      const response = await fetch(base+'products/'+encodeURIComponent(handle)+'.js',{cache:'no-store',headers:{Accept:'application/json'}});
      if (!response.ok) throw Error(upsell.dataset.availabilityError);
      return response.json();
    };
    const chosenMain = () => config.variants.find(v=>String(v.id)===String(root.querySelector('.buy-buttons-block input[name="id"]')?.value));
    function syncKlarna() {
      const price = chosenMain()?.price;
      const amount = klarna.querySelector('[data-gear-installment]');
      if (amount && Number.isFinite(price)) {
        const text = money(Math.floor(price/3));
        if (amount.textContent !== text) amount.textContent = text;
      }
    }
    syncKlarna();
    new MutationObserver(syncKlarna).observe(buy,{childList:true,subtree:true,attributes:true,attributeFilter:['value']});
    document.addEventListener('variant:update',syncKlarna);
    root.addEventListener('change',()=>queueMicrotask(syncKlarna));
    let extra, busy=false, lastSuccess=0;
    const box = upsell.querySelector('[data-gear-extra-enabled]');
    const select = upsell.querySelector('[data-gear-extra-variant]');
    const options = upsell.querySelector('[data-gear-extra-options]');
    const error = upsell.querySelector('[data-gear-bundle-error]');
    const message = text => {error.textContent=text;error.hidden=!text;};
    box.addEventListener('change',()=>{
      const singleDefaultRope=extra?.handle==='jump-rope'&&extra.variants.length===1&&extra.variants[0].title==='Default Title';
      options.hidden=!box.checked||singleDefaultRope;upsell.classList.toggle('is-selected',box.checked);message('');
    });
    select.addEventListener('change',()=>{
      const v=extra?.variants.find(v=>String(v.id)===select.value);
      if(v)upsell.querySelector('[data-gear-extra-price]').textContent=money(v.price);
      message('');
    });
    try {
      const response=await fetch(config.mappingUrl,{headers:{Accept:'application/json'}});
      if(!response.ok)throw Error(upsell.dataset.recommendationsError);
      const mapping=await response.json();
      const source=mapping.groups.find(g=>g.products.some(p=>p.handle===config.handle));
      const sourceProduct=source?.products.find(p=>p.handle===config.handle);
      for(const suggestion of source?.upsells||[]){
        const group=mapping.groups.find(g=>g.key===suggestion.model);
        const rank=p=>p.color===sourceProduct.color?0:p.color==='black'?1:2;
        const candidates=(group?.products||[]).filter(p=>p.handle!==config.handle&&(!suggestion.differentColor||p.color!==sourceProduct.color)).slice().sort((a,b)=>rank(a)-rank(b));
        for(const candidate of candidates){
          const p=await getProduct(candidate.handle);
          if(p.variants.some(v=>v.available&&v.price>0)){extra=p;break;}
        }
        if(extra)break;
      }
      if(!extra){upsell.querySelector('[data-gear-extra-status]').textContent=upsell.dataset.noRecommendation;return;}
      const first=extra.variants.find(v=>v.available&&v.price>0);
      upsell.dataset.productHandle=extra.handle;
      upsell.querySelector('[data-gear-extra-title]').textContent=extra.title;
      upsell.querySelector('[data-gear-extra-link]').href=base+'products/'+extra.handle;
      const image=upsell.querySelector('img');image.src=extra.featured_image;image.alt=extra.title;
      upsell.querySelector('[data-gear-extra-price]').textContent=money(first.price);
      extra.variants.forEach(v=>{const option=document.createElement('option');option.value=String(v.id);option.textContent=v.title+(v.available?'':' — '+upsell.dataset.soldOut);option.disabled=!v.available;option.selected=v.id===first.id;select.append(option);});
      box.disabled=false;
      box.setAttribute('aria-label',extra.title+' '+upsell.dataset.addProduct);
      upsell.querySelector('[data-gear-extra-status]').hidden=true;
      upsell.querySelector('[data-gear-extra-card]').hidden=false;
      upsell.dataset.ready='true';
    }catch(e){upsell.querySelector('[data-gear-extra-status]').textContent=e.message;}
    async function add(button) {
      if(busy||Date.now()-lastSuccess<1200)return;
      const mainVariant=chosenMain();
      if(!mainVariant?.available){message(upsell.dataset.mainUnavailable);return;}
      const extraId=select.value;
      if(!extraId||select.selectedOptions[0]?.disabled){message(upsell.dataset.chooseExtra);select.focus();return;}
      busy=true;
      const buttons=[...root.querySelectorAll('.buy-buttons-block button[name="add"]'),...document.querySelectorAll('#ea-sticky-cart-root .eascStickyAddToCartBtn')];
      const previous=buttons.map(b=>b.disabled);buttons.forEach(b=>{b.disabled=true;b.setAttribute('aria-busy','true');});message('');
      try{
        const [main,currentExtra]=await Promise.all([getProduct(config.handle),getProduct(extra.handle)]);
        if(!main.variants.some(v=>String(v.id)===String(mainVariant.id)&&v.available))throw Error(upsell.dataset.mainChanged);
        if(!currentExtra.variants.some(v=>String(v.id)===extraId&&v.available))throw Error(upsell.dataset.extraChanged);
        const qty=Math.max(1,Math.min(999,Number(root.querySelector('.buy-buttons-block input[name="quantity"]')?.value)||1));
        const items=[{id:Number(mainVariant.id),quantity:qty},{id:Number(extraId),quantity:qty}];
        const sections=[...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(e=>e.dataset.sectionId))].slice(0,5);
        const response=await fetch(base+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items,sections,sections_url:location.pathname})});
        const added=await response.json();if(!response.ok||added.status)throw Error(added.description||added.message||upsell.dataset.addFailed);
        lastSuccess=Date.now();
        const cart=await fetch(base+'cart.js',{cache:'no-store'}).then(r=>r.json());
        root.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{resource:cart,sourceId:String(mainVariant.id),data:{source:'product-form-component',productId:String(main.id),itemCount:qty*2,sections:added.sections}}}));
        if(window.SternifyCart?.open){await window.SternifyCart.loadCart?.();window.SternifyCart.open();}
      }catch(e){message(e.message);}finally{busy=false;buttons.forEach((b,i)=>{b.disabled=previous[i];b.removeAttribute('aria-busy');});}
    }
    window.addEventListener('click',event=>{
      if(!root.isConnected||!box.checked)return;
      const b=event.target.closest('[data-nspire-catalog="gear"] .buy-buttons-block button[name="add"],#ea-sticky-cart-root .eascStickyAddToCartBtn');
      if(!b||b.disabled)return;event.preventDefault();event.stopImmediatePropagation();add(b);
    },true);
    window.addEventListener('submit',event=>{
      if(!root.isConnected||!box.checked||!event.target.matches('[data-nspire-catalog="gear"] .buy-buttons-block form'))return;
      event.preventDefault();event.stopImmediatePropagation();add();
    },true);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
  document.addEventListener('shopify:section:load',boot);
})();
